import React from 'react';
import { IsObjectEmpty, IsStringEmpty, GetObjectClone } from '../../../utilities/CommonMethods';
import FormFields from '../FormFields';
import classes from './EditLiveSessionDetailForm.module.css';
import Button from '../../UI/Button/Button';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import FlexModal from '../../UI/FlexModal/FlexModal';
import NewInputDropDown from '../../UI/NewInputDropdown/NewInputDropDown';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowMiniLoader from "../../../hoc/ShowMiniLoader/ShowMiniLoader";
import { parseTimeForInputField, parseDateForInputField } from '../../../utilities/DateTimeUtils';
import Input from '../../UI/Input/Input';

class EditLiveSessionDetailForm extends React.Component {

    state = {
        liveSessionFormData: GetObjectClone(FormFields.liveSessionFormData),
        allStatusList: [{ id: 1, name: "upcoming" }, { id: 2, name: "ended" }, { id: 3, name: "started" },],
        selectedPos: 0,
        selectedPosZoom: 0,
        status: "",
        isLoadingButton: false,
        zoomAccount: "",
        zoomAccountList: [
            { id: 0, accountNo: 0, name: "" },
            { id: 35, accountNo: 40, name: "AwantikZeke" },
            { id: 34, accountNo: 39, name: "AwantikNew" },
            { id: 33, accountNo: 38, name: "Arman" },
            { id: 32, accountNo: 37, name: "EDYODA" },
            { id: 1, accountNo: 36, name: "Kunal4" },
            { id: 2, accountNo: 35, name: "Kunal3" },
            { id: 3, accountNo: 34, name: "Vaibhav6" },
            { id: 4, accountNo: 33, name: "Vaibhav4" },
            { id: 5, accountNo: 32, name: "Prithvi4" },
            { id: 6, accountNo: 31, name: "Vaibhav5" },
            { id: 7, accountNo: 30, name: "Vaibhav3" },
            { id: 8, accountNo: 29, name: "Prithvi3" },
            { id: 9, accountNo: 28, name: "Awantik2" },
            { id: 10, accountNo: 27, name: "Ashish2" },
            { id: 11, accountNo: 26, name: "Prithvi2" },
            { id: 12, accountNo: 25, name: "Kunal2" },
            { id: 13, accountNo: 24, name: "Support2" },
            { id: 14, accountNo: 23, name: "Admissions2" },
            { id: 15, accountNo: 22, name: "Events2" },
            { id: 16, accountNo: 21, name: "Vaibhav2" },
            { id: 17, accountNo: 20, name: "Jishnav2" },
            { id: 18, accountNo: 19, name: "Prithviraj2" },
            { id: 19, accountNo: 18, name: "Admissions" },
            { id: 20, accountNo: 17, name: "Support" },
            { id: 21, accountNo: 16, name: "jishnav" },
            { id: 22, accountNo: 14, name: "prithviraj" },
            { id: 23, accountNo: 13, name: "prithvi" },
            { id: 24, accountNo: 12, name: "Vaibhav" },
            { id: 25, accountNo: 11, name: "Ashish" },
            { id: 26, accountNo: 10, name: "Events" },
            { id: 27, accountNo: 9, name: "Kunal" },
            { id: 28, accountNo: 8, name: "Awantik" },
            { id: 29, accountNo: 15, name: "shannon" },
            { id: 30, accountNo: 7, name: "Qaifi" },
            { id: 31, accountNo: 6, name: "Mohit" },

        ],
    }

    componentDidMount() {
        this.setFormData();
        for (let i = 0; i < this.state.zoomAccountList.length; i++) {
            if (this.props.data.liveSessionList[0].zoomAccount === this.state.zoomAccountList[i].accountNo) {
                this.setState({
                    zoomAccount: this.state.zoomAccountList[i].name,
                    selectedPosZoom: i
                })
            }
        }
        for (let i = 0; i < this.state.allStatusList.length; i++) {
            if (this.state.allStatusList[i].name === this.props.data.liveSessionList[0].status) {
                this.setState({
                    status: this.state.allStatusList[i].name,
                    selectedPos: i
                })
            }
        }
    }
    getSelectedStatus = (pos) => {
        this.setState({ status: this.state.allStatusList[pos].name, selectedPos: pos });

    }
    getSelectedZoomAccount = (pos) => {
        this.setState({ zoomAccount: this.state.zoomAccountList[pos].name, selectedPosZoom: pos });

    }
    setFormData = () => {
        const liveSessionData = !IsObjectEmpty(this.props.data.liveSessionList[0]) ? this.props.data.liveSessionList[0] : {};
        if (!IsObjectEmpty(liveSessionData)) {
            // alert('Setting UP Initial Data');

            let startURL = '', signature = '', meetId = '', password = '', encPassword = '', startDate = '', startTime = '', endDate = '', endTime = '';

            startURL = !IsStringEmpty(liveSessionData.startURL) ? liveSessionData.startURL : '';
            signature = !IsStringEmpty(liveSessionData.signature) ? liveSessionData.signature : '';
            meetId = !IsStringEmpty(liveSessionData.meetId) ? liveSessionData.meetId : '';
            password = !IsStringEmpty(liveSessionData.password) ? liveSessionData.password : '';
            encPassword = !IsStringEmpty(liveSessionData.encPassword) ? liveSessionData.encPassword : '';
            startDate = !IsStringEmpty(liveSessionData.startDateTime) ? parseDateForInputField(liveSessionData.startDateTime) : '';
            endDate = !IsStringEmpty(liveSessionData.endDateTime) ? parseDateForInputField(liveSessionData.endDateTime) : '';
            startTime = !IsStringEmpty(liveSessionData.startTime) ? parseTimeForInputField(liveSessionData.startTime) : '';
            endTime = !IsStringEmpty(liveSessionData.endTime) ? parseTimeForInputField(liveSessionData.endTime) : '';

            let updatedFormData = { ...this.state.liveSessionFormData };
            updatedFormData['startURL'].value = startURL;
            updatedFormData['signature'].value = signature;
            updatedFormData['meetId'].value = meetId;
            updatedFormData['password'].value = password;
            updatedFormData['encPassword'].value = encPassword;
            updatedFormData['startDate'].value = startDate;
            updatedFormData['startTime'].value = startTime;
            updatedFormData['endDate'].value = endDate;
            updatedFormData['endTime'].value = endTime;
            this.setState({ liveSessionFormData: updatedFormData });


        } else {
            // alert('Adding a new Problem');
        }
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.liveSessionFormData };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };
        let inputValue = event.target.value;
        updatedFormElement.value = inputValue;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        this.setState({ liveSessionFormData: updatedForm });
    }
    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.liveSessionFormData[key].elementType}
            elementConfig={this.state.liveSessionFormData[key].elementConfig}
            label={this.state.liveSessionFormData[key].label}
            value={this.state.liveSessionFormData[key].value}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.liveSessionFormData[key].touched} />
    }

    onFormButtonClicked = () => {
        this.setState({ isLoadingButton: true, });
        let response = {
            "created_At": this.props.data.liveSessionList[0].createdAt,
            "scheduled_At": this.props.data.liveSessionList[0].scheduledAt,
            "zoom_account": this.state.zoomAccount,
            "status": this.state.status,
            "start_date_time": this.state.liveSessionFormData.startDate.value + " " + this.state.liveSessionFormData.startTime.value,
            "end_date_time": this.state.liveSessionFormData.endDate.value + " " + this.state.liveSessionFormData.endTime.value,
            "start_url": this.state.liveSessionFormData.startURL.value,
            "signature": this.state.liveSessionFormData.signature.value,
            "meet_id": this.state.liveSessionFormData.meetId.value,
            "password": this.state.liveSessionFormData.password.value,
            "enc_password": this.state.liveSessionFormData.encPassword.value,
        };
        var liveSessionId = !IsObjectEmpty(this.props.data.liveSessionList[0]) && !IsStringEmpty(this.props.data.liveSessionList[0].liveSessionId) ? this.props.data.liveSessionList[0].liveSessionId : null;
        ResourceAPIController.editLiveSessionDetail(response, liveSessionId)
            .then(response => {
                this.props.closePopup();
                this.props.getCurriculumPageData();
                this.props.onSuccessDialogShow(response.result, 'DONE');

            })
            .catch(err => {
                this.props.closePopup();
                console.log("Copy Live Session Detail Form Error Message", err.error.message);
                this.setState({ errorMessage: err.error.message, isLoadingButton: false });
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                } else if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    render() {
        return (
            <FlexModal visible={true} forSessionPlanForm={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.Form}>
                    <h5 className={classes.Heading}>Edit Live Session Details</h5>

                    <img src={CloseIcon} alt={'Hide form'} className={classes.CloseIcon}
                        onClick={this.props.closePopup} />
                    <table border='0' cellSpacing='0' className={classes.Table}>
                        <tbody>
                            <tr className={classes.TableRow}>
                                <td className={classes.FieldName} align='left'>Created At :</td>
                                <td>
                                    {this.props.data.liveSessionList[0].createdDate}&nbsp;,{this.props.data.liveSessionList[0].createdTime}
                                </td>
                            </tr>
                            <tr className={classes.TableRow}>
                                <td className={classes.FieldName} align='left'>Scheduled At :</td>
                                <td>
                                    {this.props.data.liveSessionList[0].scheduledDate}&nbsp;,{this.props.data.liveSessionList[0].scheduledTime}
                                </td>
                            </tr>
                            <tr className={classes.TableRow}>
                                <td className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                    {this.inputField('startDate')}
                                </td>
                                <td className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                    {this.inputField('startTime')}
                                </td>
                            </tr>
                            <tr className={classes.TableRow}>
                                <td className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                    {this.inputField('endDate')}
                                </td>
                                <td className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                    {this.inputField('endTime')}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className={classes.Inputs}>
                        <NewInputDropDown
                            title={"Zoom Account"}
                            padding={true}
                            dropdownItemsList={this.state.zoomAccountList}
                            activeItemPos={this.state.selectedPosZoom}
                            dropdownItemClicked={this.getSelectedZoomAccount}
                            reduceTopMargin={true}
                            width={"100%"}
                        />
                        <NewInputDropDown
                            title={"Status"}
                            padding={true}
                            dropdownItemsList={this.state.allStatusList}
                            activeItemPos={this.state.selectedPos}
                            dropdownItemClicked={this.getSelectedStatus}
                            reduceTopMargin={true}
                        />

                        {this.inputField('password')}
                        {this.inputField('meetId')}
                        {this.inputField('encPassword')}
                        {this.inputField('signature')}
                        {this.inputField('startURL')}
                    </div>



                    <div className={classes.SubmitButton}>
                        {!this.state.isLoadingButton ? (
                            <Button
                                styleclass="NonMobileOnly"
                                label={"SAVE DETAILS"}
                                fontSize="0.8em"
                                padding="1em 3.5em"
                                margin="0 0 1.5em 0"
                                clicked={this.onFormButtonClicked}
                            />
                        ) : (
                            <div className={classes.LoaderBar}>
                                <ShowMiniLoader isLoading={true} transparentBg={true} />
                            </div>
                        )}
                    </div>
                </div>
            </FlexModal>
        );
    }

}

export default EditLiveSessionDetailForm;